function getDaysInMonth(month, year) {
  const date = new Date(year, month, 1)
  const days = []
  let idx = 0
  while (date.getMonth() === month && idx < 15) {
    const d = new Date(date)
    days.push(d.getDate() + ' ' + d.toLocaleString('en-us', { month: 'short' }))
    date.setDate(date.getDate() + 1)
    idx += 1
  }
  return days
}
const now = new Date()
const labels = getDaysInMonth(now.getMonth(), now.getFullYear())
const revenueAreaChart = {
  chartOptions: {
    chart: {
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      theme: 'dark',
      x: { show: false },
    },
    stroke: {
      curve: 'smooth',
      width: 3,
    },
    zoom: {
      enabled: false,
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: true,
    },
    colors: ['#5369f8', '#f77e53', '#43d39e', '#ffbe0b'],
    xaxis: {
      type: 'string',
      categories: labels,
      tooltip: {
        enabled: false,
      },
      axisBorder: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        formatter(val) {
          return val + 'k'
        },
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        type: 'vertical',
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.00,
        opacityTo: 0.00,
        stops: [45, 100],
      },
    },
  },
  series: [
    {
      name: 'Product 2',
      data: [30, 40, 15, 15, 15, 25, 10, 25, 30, 30, 25, 30, 35, 40, 30],
    },
    {
      name: 'Apple',
      data: [10, 50, 5, 15, 20, 20, 25, 15, 20, 40, 25, 20, 35, 30, 25],
    },
    {
      name: 'Lime',
      data: [20, 30, 10, 25, 10, 30, 15, 25, 10, 20, 25, 30, 30, 40, 35],
    },
    {
      name: 'Pineapple',
      data: [5, 10, 20, 35, 20, 20, 15, 35, 20, 40, 25, 40, 45, 50, 35],
    },
  ],
}

const targetsBarChart = {
  chartOptions: {
    colors: ['#5369f8', '#43d39e', '#f77e53', '#ffbe0b'],
    chart: {
      type: 'bar',
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '75%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: ['Jun'],
      // categories: ['Jul'],
      axisBorder: {
        show: false,
      },
    },
    legend: {
      show: true,
      position: 'right',
      horizontalAlign: 'left',
      itemMargin: {
        horizontal: 6,
        vertical: 3,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
    grid: {
      row: {
        colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.2,
      },
      borderColor: '#f3f4f7',
    },
    tooltip: {
      y: {
        formatter: function(val) {
          return val
        },
      },
    },
  },
  series: [
    {
      name: 'Product 2',
      // data: [230, 320, 411],
      data: [411],
    },
    {
      name: 'Apple',
      // data: [120, 160, 280],
      data: [280],
    },
    {
      name: 'Lime',
      // data: [200, 180, 257],
      data: [257],
    },
    {
      name: 'Pineapple',
      // data: [220, 210, 242],
      data: [242],
    },
  ],
}



const salesBarChart = {
  chartOptions: {
    colors: ['#5369f8', '#43d39e', '#f77e53', '#ffbe0b'],
    chart: {
      type: 'bar',
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        columnWidth: '45%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: ['Abel Wondimagegne', 'Ruth Admassu', 'Biruk Mehari', 'Biruk Kassahun', 'Ermias Getahun', 'Dawit Solomon', 'Seyoum Alemayehu', 'Eyerusalem G/Hiwot', 'Hirut Zewdu'],
      // categories: ['Jul'],
      axisBorder: {
        show: false,
      },
      tickPlacement: 'between'
    },
    legend: {
      show: true,
      position: 'right',
      horizontalAlign: 'left',
      itemMargin: {
        horizontal: 6,
        vertical: 3,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
    grid: {
      row: {
        colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.2,
      },
      borderColor: '#f3f4f7',
    },
    tooltip: {
      y: {
        formatter: function(val) {
          return val
        },
      },
    },
  },
  series: [
    {
      name: '',
      data: [200000, 75000, 72000, 52000, 30000, 20000, 20000, 8000, 2000],
    },
    
  ],
}


const ordersData = [
  {
    id: '1',
    employee: 'Ethiopian Airlines',
    name: 'Tewodros Gebeyehu',
    memberId: 'HirtwI6V5zrsunxSMTq1',
    status: 'Pending',
  },
  {
    id: '2',
    employee: 'Ethio Telecom',
    name: 'Abdurezak Mohammed',
    memberId: 'K02aYvg85gYWhfzzcyoY',
    status: 'Resolved',
  },
  {
    id: '3',
    employee: 'Ethiopian Airlines',
    name: 'Tesfay Hagos',
    memberId: 'HirtwI6V5zrsunxSMTq1',
    status: 'Dismissed',
  },
  {
    id: '4',
    employee: 'Minstry of Education',
    name: 'Hiwot Alemayehu',
    memberId: 'K02aYvg85gYWhfzzcyoY',
    status: 'Resolved',
  },
  {
    id: '5',
    employee: 'Minstry of Mines',
    name: 'Sofia Hassen',
    memberId: 'HirtwI6V5zrsunxSMTq1',
    status: 'Pending',
  },
]


const bottomOrdersData = [
  {
    id: '159',
    product: 'Adane Resraurant',
    name: 'Adane Resraurant',
    price: '800.00',
    status: 'Pending',
  },
  {
    id: '160',
    product: 'Emebet Grocery',
    name: 'Emebet Grocery',
    price: '400.00',
    status: 'Delivered',
  },
  {
    id: '161',
    product: 'National',
    name: 'National',
    price: '400.00',
    status: 'Declined',
  },
  {
    id: '162',
    product: 'Lideta B&R',
    name: 'Lideta B&R',
    price: '400.00',
    status: 'Delivered',
  },
  {
    id: '163',
    product: 'Fasika B&R',
    name: 'Fasika B&R',
    price: '400.00',
    status: 'Declined',
  },
]

export { revenueAreaChart, targetsBarChart, salesBarChart , ordersData, bottomOrdersData }
